import React from 'react';
import PropTypes from 'prop-types';

// Assets
import {black500, greyishBlue100, greyishBlue500} from "assets/jss/main";
import {ReactComponent as CloseIcon} from "assets/img/wms/close_medium.svg";
import PageTitle from "../../../Mobile/PageTitle";
import {Grid} from "@mui/material";

RightDrawerDesktopHead.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onClose: PropTypes.func,
    withoutBorder: PropTypes.bool
};

function RightDrawerDesktopHead({title, subtitle, onClose, children, withoutBorder = false}) {
    return (
        <Grid container direction={'column'} sx={{
            background: '#fff',
            width: '100%',
            position: 'sticky',
            top: 0,
            paddingTop: '48px',
            borderBottom: withoutBorder ? "none" : `1px solid ${greyishBlue100}`,
            zIndex: 1,
        }}>
            <Grid item style={{
                position: 'absolute',
                top: 48,
                right: 40,
            }}>
                <CloseIcon onClick={() => onClose()} />
            </Grid>
            <Grid item>
                <PageTitle
                    title={title}
                    subtitle={subtitle}
                    isDesktop
                    customPadding={"0px 0px 0px 40px"}
                />
            </Grid>
            {children && (
                <Grid
                    item
                    sx={{
                        paddingX: "32px",
                        marginTop: "20px"
                    }}
                >
                    {children}
                </Grid>
            )}
        </Grid>
    );
}

export default RightDrawerDesktopHead;
